import { render, staticRenderFns } from "./ASorRbuEditor.vue?vue&type=template&id=353f2bb6"
import script from "./ASorRbuEditor.vue?vue&type=script&lang=js"
export * from "./ASorRbuEditor.vue?vue&type=script&lang=js"
import style0 from "./ASorRbuEditor.vue?vue&type=style&index=0&id=353f2bb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports